/**
 * @fileoverview POST handler for the "/app_settings/:app_group_id/message_prioritization/rules" endpoint
 */
import fetch from "@lib/fetch";

import {
  createMutationFetcherFunctionWithShadowError,
  reactQueryMutationAdapter,
} from "../reactQueryFetcherAdapters";
import { appSettingsAppGroupIdMessagePrioritizationRulesCacheKeys } from "./constants";
import { transformProps } from "./transform";
import type {
  MessagePrioritizationRuleUpsertErrors,
  PostMessagePrioritizationRulesProps,
  PostMessagePrioritizationRulesResult,
} from "./types";

export const postMessagePrioritizationRules = reactQueryMutationAdapter(
  appSettingsAppGroupIdMessagePrioritizationRulesCacheKeys,
  createMutationFetcherFunctionWithShadowError<MessagePrioritizationRuleUpsertErrors>()(
    (props: PostMessagePrioritizationRulesProps): Promise<PostMessagePrioritizationRulesResult> => {
      const body = transformProps(props);
      return fetch(`/app_settings/${props.appGroupId}/message_prioritization/rules`, "POST", body, undefined, {
        // don't display a modal on fetch errors
        propagateFetchRequestError: false,
      });
    }
  )
);
